import { Helmet } from "react-helmet";
import { Box, Container, Grid } from "@material-ui/core";
import Budget from "src/components/dashboard/Budget";
import LatestOrders from "src/components/dashboard/LatestOrders";
import AmountLending from "src/components/dashboard/AmountLending";
import TotalProfit from "src/components/dashboard/TotalProfit";
import { useEffect } from "react";
import useAccount from "../hooks/useAccount";

const Dashboard = () => {
  const { getDashboard, statistic, getActivities, activities } = useAccount();

  useEffect(async () => {
    await getDashboard();
    const dateFrom = new Date();
    let month = dateFrom.getMonth() + 1;
    let day = dateFrom.getDate();
    if (month < 10) {
      month = `0${month}`;
    }
    if (day < 10) {
      day = `0${day}`;
    }
    const dateFromFormatted = `${dateFrom.getFullYear()}-${month}-${day}`;
    await getActivities({
      dateFrom: dateFromFormatted,
      dateTo: dateFromFormatted
    });
  }, []);
  return (
    <>
      <Helmet>
        <title>Trang chủ</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Grid container spacing={3}>
            <Grid item lg={4} sm={4} xl={4} xs={12}>
              <Budget statistic={statistic} />
            </Grid>
            <Grid item lg={4} sm={4} xl={4} xs={12}>
              <AmountLending statistic={statistic} />
            </Grid>
            <Grid item lg={4} sm={4} xl={4} xs={12}>
              <TotalProfit sx={{ height: "100%" }} statistic={statistic} />
            </Grid>
            <Grid item lg={12} md={12} xl={12} xs={12}>
              <LatestOrders activities={activities} />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Dashboard;
